import { configureStore } from "@reduxjs/toolkit";

import userPickReducer from "./picks/userPick-slice";
import wheelReducer from "./wheel-slice";
import carouselReducer from "./picks/carousel-slice";
import tabReducer from "./picks/tabs-slice";
import configReducer from "./config-slice";
import audioReducer from "./audio-slice";

export const store = configureStore({
  reducer: {
    picks: userPickReducer,
    wheel: wheelReducer,
    carousel: carouselReducer,
    tab: tabReducer,
    config: configReducer,
    audio: audioReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
